/**
 * Check whether a click target is inside a MUI portal (popover/menu/autocomplete)
 * or the slide editor toolbar. Useful for preventing click-away
 * dismissals when the user interacts with toolbar dropdowns that
 * render outside the editor's DOM tree.
 */
export function isClickInsideEditorPortal(target: EventTarget | null): boolean {
  if (!(target instanceof Node)) return false;
  // Walk up from Text nodes (some browsers may report them as mousedown targets)
  const element = target instanceof Element ? target : target.parentElement;
  if (!element) return false;
  if (element.closest('.MuiPopover-root, .MuiMenu-root')) return true;
  // Autocomplete dropdowns (TypeaheadSelectInput) render in a Popper, not a
  // Popover, so they need their own check to avoid blurring the input before
  // the click event reaches the selected option.
  if (element.closest('.MuiAutocomplete-popper')) return true;
  if (element.closest('[data-slide-editor-toolbar]')) return true;
  if (element.closest('[data-slide-editor-variable-picker]')) return true;
  return false;
}
